import useSize from "../../../../Utils/useSize/useSize";
import toast from "react-hot-toast";
import { useCallback, useEffect, useMemo, useState } from "react";
import Backend from "../../../../Backend/Backend";
import Loading from "../../../../Utils/Loading/Loading";
import NotFound from "../../../../Utils/NotFound/NotFound";
import TopHeader from "./TopHeader";
import TransactionCard from "./TransactionCard/TransactionCard";
import moment from "moment";

const backend = await new Backend().init();

export default function TransactionHistory() {
  const windowSize = useSize();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("all");

  // Date range state
  const [start] = useState(moment().startOf("week"));
  const [end] = useState(moment().endOf("week"));

  useEffect(() => {
    loadTransaction();
  }, []);

  const loadTransaction = useCallback(
    async (startDate = start, endDate = end) => {
      setLoading(true);
      try {
        const payload = {
          server: localStorage.getItem("server"),
          id: localStorage.getItem("id"),
          user_id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          username: localStorage.getItem("username"),
          start: startDate,
          end: endDate,
        };

        const res = await backend.transaction(payload);

        if (res.error === "False") {
          setTransactions(res.transactions || []);
        } else {
          if (res.logout === 1) {
            window.LogOut();
          } else {
            toast.error(res.message);
          }
        }
      } catch (err) {
        console.error("Failed to load transactions:", err);
        toast.error(
          "Network Error. Could not connect to the server. Please try again.",
        );
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  // --- Memoized Sorting ---
  // This derived state ensures the UI stays sorted even when 'trade' updates via socket
  const sortedTrade = useMemo(() => {
    if (!transactions) return [];

    switch (sortBy) {
      case "payment_id":
        // Show only deposits
        return transactions.filter((item) => item.payment_id);

      case "withdrawal_id":
        // Show only withdrawals
        return transactions.filter((item) => item.withdrawal_id);

      case "processing":
        // status = 0
        return transactions.filter((item) => Number(item.status) === 0);

      case "successful":
        // status = 1
        return transactions.filter((item) => Number(item.status) === 1);

      case "rejected":
        // status = 2
        return transactions.filter((item) => Number(item.status) === 2);

      case "all":
      default:
        return transactions;
    }
  }, [transactions, sortBy]);

  return (
    <div className="flex flex-col">
      {/* Header */}
      <TopHeader
        sortBy={sortBy}
        onSort={setSortBy} // Pass setSortBy directly
        reload={loadTransaction}
      />

      {/* Main Content */}
      <div className="flex-1 px-3 pb-3">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <Loading height={windowSize[1] - 90} />
          </div>
        ) : sortedTrade.length > 0 ? (
          <div
            style={{
              height: windowSize[1] - 90,
              overflowY: "auto", // auto is generally safer than scroll
              scrollBehavior: "smooth",
              paddingBottom: 200,
            }}
            className="flex flex-col gap-3"
          >
            {sortedTrade.map((item) => (
              <TransactionCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            small
            height={windowSize[1] - 90}
            title="Nothing here"
            subtext="No Symbol Logs Found."
          />
        )}
      </div>
    </div>
  );
}
